import React, { useState } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";
import "./styles.css"; // Make sure this is imported to apply styles

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showReset, setShowReset] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/admin");
    } catch (error) {
      alert("Login failed: " + error.message);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      alert("Please enter your email first.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage(
        "If your email is in our system, a password reset link has been sent. Please check your inbox and your spam folder for an email from noreply@swe-intern-db.firebaseapp.com."
      );
    } catch (error) {
      alert("Failed to send reset email: " + error.message);
    }
  };

  return (
    <div
      style={{
        maxWidth: "400px",
        margin: "3rem auto",
        background: "#fff",
        padding: "2rem",
        borderRadius: "10px",
        fontFamily: "Raleway, sans-serif",
      }}
    >
      <h2>Admin Login</h2>
      <p style={{ fontSize: "0.9rem", color: "#555", marginBottom: "1rem" }}>
        This login is for <strong>site administrators only</strong>. You do not need to log in to submit an internship.
      </p>

      <form onSubmit={handleLogin}>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "1rem" }}
        />

        {!showReset && (
          <>
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: "100%", marginBottom: "1rem" }}
            />
            <button type="submit" className="login-button" style={{ width: "100%" }}>
              Log In
            </button>
            <button
              type="button"
              onClick={() => setShowReset(true)}
              style={{
                marginTop: "1rem",
                background: "none",
                border: "none",
                color: "#4497CB",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Forgot Password?
            </button>
          </>
        )}

        {showReset && (
          <>
            <button
              type="button"
              onClick={handlePasswordReset}
              className="login-button"
              style={{ width: "100%" }}
            >
              Send Password Reset Email
            </button>
            <button
              type="button"
              onClick={() => {
                setShowReset(false);
                setMessage("");
              }}
              style={{
                marginTop: "0.5rem",
                background: "none",
                border: "none",
                color: "#4497CB",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Back to Login
            </button>
          </>
        )}
      </form>

      {message && <div className="notice-box" style={{ marginTop: "1.5rem" }}>{message}</div>}
    </div>
  );
}

export default LoginPage;

